if (!customElements.get("collapsible-tab")) {
    class CollapsibleTab extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            this.destroy();
        }

        init() {
            console.log("Initializing collapsible tab:", this); // 添加调试信息
            this.dataset.destroy !== "true" && (this.setDefaultData(), this.attachEvents(),
                this.getAttribute("open") === "true" ? (
                    this.selected = !0,
                    this.classList.add(this.expandedClass, this.selectedClass),
                    this.setExpandedAria(),
                    this.fire("tabOpened"),
                    window.FoxThemeEvents.emit("ON_COLLAPSIBLE_TAB_OPENED", this)
                ) : (
                    this.content.style.height = this.collapsedHeight,
                    this.classList.add(this.collapsedClass),
                    this.setCollapsedAria()
                ),
                this.content.removeAttribute("hidden"));
        }

        // 保持其他代码不变
    }

    customElements.define("collapsible-tab", CollapsibleTab);
}
